const getLabels = () => ({
  addedDevice: 'Added Device',
	azzurroHubBusy: 'Azzurro Hub is busy, please try again later',
	azzurroHubBusyDescription: 'Azzurro Hub is busy, please try again later',
	deviceNotOnline: 'Device is not online',
	fwUpgradeInProgress: 'Firmware upgrade in progress',
	fwVersionNotValidUpgradeRequired: 'Firmware version not valid, upgrade required',
	hasOwnerAndItsNotYou: 'Device has an owner and it is not you',
	iAmAlreadyAdmin: 'I am already an admin',
	serialNotValid: 'Serial not valid',
	validationError: 'Validation error',
  add: 'Add',
  addInverter: 'Add',
  admin: 'Admin',
  alreadyInserted: 'Already inserted',
  alreadyInsertedDescription: 'The selected logger is already inserted in the system',
  applyRegistration: 'Apply registration',
  atLeastOneOwner: 'At least one owner is required',
  connextDisconnectedDisclaimer: 'The Connext is disconnected. Only some settings can be modified.',
  authorizations: 'Authorizations',
  backButton: 'Back',
  checkAgain: 'Check again',
  chooseLogger: 'Choose Logger',
  chooseLoggerTitle: 'Select the monitoring logger you purchased, specify the plant location for proper configuration, and add devices to the photovoltaic system. By doing so, your plant will be ready to operate effectively.',
  configurationStepLabel: 'Configuration',
  connext: 'Connext',
  connextPlaceholder: 'E.g. CA...',
  connextSerial: 'Connext Serial',
  azzurroHub: 'Azzurro Hub',
  azzurroHubPlaceholder: 'E.g. AH1234567890',
  azzurroHubSerial: 'Azzurro Hub Serial',
  azzurroHubConfiguration: 'Azzurro Hub Configuration',
  azzurroHubDevices: 'Azzurro Hub Devices',
  contractPowerDescription: 'Enter the contracted power in watts (W). This information can be found on your bill, usually on the first or second page, under the Contract Type section or in the Supply Data.',
  contractPowerPlaceholder: 'Example: 3000 W',
  contractPowerTitle: 'Contract power',
  createButton: 'Create',
  createTitle: 'Create Plant',
  delete: 'Delete',
  deleteForAll: 'Delete for all',
  deleteForMe: 'Delete for me',
  deleteSelected: 'Delete & save',
  deviceAlreadyExistsInYourSystemList: 'Device already exists in your system list',
  deviceAlreadyOnACertifiedPlant: 'Device already on a certified plant',
  deviceListDescription: 'Enter the list of your devices specifying the serial numbers and configuration details. You can find the device serial number on the adhesive label.',
  deviceListPlaceholder: 'E.g. ZM2...',
  deviceListTitle: 'Device List',
  deviceListContent: 'Device List',
  deviceNotExist: 'Device does not exist',
  deviceNotExists: 'Device does not exist',
  deviceRegistrationError: 'Error registering the device',
  devices: 'Devices',
  devicesStepLabel: 'Devices',
  email: 'Email',
  emailNotValid: 'Email not valid',
  error: 'Error',
  genericErrorMessage: 'i18n.Common.genericErrorMessage',
  externalPower: 'External power',
  externalPowerConsider: 'Consider',
  externalPowerDescription: 'With this option, you can choose whether or not to consider external power on your hybrid inverter in the calculation of total power.',
  externalPowerNotConsider: 'Do not consider',
  externalPowerSelectionPlaceholder: 'Example: Consider',
  finishButton: 'Go to System',
  firmwareNotValidDescription: 'An upgrade is required to continue.',
  firmwareOperationDescription: 'Firmware update in progress, please wait a few minutes',
  fwUpdateContent: 'The firmware update is in progress. Please wait a few minutes.',
  fwUpdateTitle: 'Firmware Update',
  homeButton: 'Home',
  hubSpecificSensor: 'Hub Specific Sensor',
  hubSensorDesc: 'The reading of this sensor will be used for Azzurro Hub calculations',
  hubSensorPlaceholder: 'E.g. 3',
  import: 'Import',
  inverterListDescription: 'Enter the list of your devices specifying the serial numbers and the Modbus address. You can find the device serial number on the adhesive label. For example, for inverters, the label is located on the side.',
  inverterListPlaceholder: 'E.g. ZM2',
  inverterListTitle: 'Inverter List',
  inverterModbusDescription: 'Enter the Modbus address already assigned to the inverter',
  inverterModbusDescriptionInnerCard: 'Make sure to enter the Modbus (RS485) address configured on the inverter. If you have any doubts, contact the installer.',
  inverterModbusPlaceholder: 'E.g. 1',
  inverterRegistrationError: 'Error registering the inverter',
  inverters: 'Inverters',
  inverterVirtualListDescription: 'Enter the list of your devices specifying the serial numbers. You can find the device serial number on the adhesive label. For example, for inverters, it is located on the side.',
  locationDescription: 'Select the location of your plant on the map. It will allow you to have accurate monitoring.',
  locationTitle: 'Location',
  loggerStepLabel: 'Logger',
  mapCoordinationPlaceholder: 'E.g. 5, Via di San Pietro, Rome',
  meterSignDescription: 'With this option you can change the sign of the meter.',
  meterSignInverted: 'Inverted',
  meterSignNormal: 'Normal',
  meterSignPlaceholder: 'Example: Normal',
  meterSignTitle: 'Meter sign (import/export)',
  monitoringModeTitle: 'Monitoring Mode',
  monitoringModeDescription: 'Select how the Azzurro Hub reads power and energy exchange data from your plant. This determines the monitoring source for power consumption and production.',
  monitoringModePlaceholder: 'Example: Inverter Master',
  monitoringModeInverterMaster: 'Inverter Master - Use inverter for PCC monitoring',
  monitoringModeMeterMaster: 'Meter Master - Use meter (modbus address 1) for PCC monitoring',
  monitoringModeInternalSensor: 'Internal Sensor - Use internal sensor for PCC monitoring (only 1 phase)',
  monitoringModePowerMagic: 'Power Magic Master - Use power magic for PCC monitoring',
  monitoringModeNone: 'No PCC monitoring',
  multiplicativeConstant: 'Multiplicative constant',
  nextButton: 'Next',
  offlineDevice: 'Offline device',
  offlineDeviceDescription: 'The device is offline. To continue, the device needs to be online.',
  others: 'Others',
  owner: 'Owner',
  phaseSelectPlaceholder: 'Example: Single phase',
  plantAlreadyCreated: 'The plant has already been created',
  plantAlreadyCreatedDescription: 'You can add the plant with view-only rights',
  plantCreationConnextApply: 'Apply',
  plantCreationConnextDisclaimer: 'By applying the changes, if the plant has no owners, you will be assigned as the owner. Remember that for proper configuration, it is necessary to add the devices connected to your Connext.',
  plantCreationTitle: 'Plant creation',
  plantName: 'Plant name',
  plantNamePlaceholder: 'E.g. Giovanni House',
  plantTypeDescription: 'Choose the type of plant, Single-phase or Three-phase',
  plantTypeDisabled: 'This setting is blocked by the configuration of the installed devices.',
  plantTypeTitle: 'Plant type',
  productionSensor: 'Production Sensor',
  productionSensorDesc: 'The reading of this sensor will be used to calculate the power production',
  productionSensorDescWithConstMultiplicative: 'Set the multiplicative constant, it will be used in the calculation of the produced power',
  productionSensorPlaceholder: 'E.g. 3',
  registered: 'Registered',
  requiredOperation: 'Required operation',
  restore: 'Restore',
  restoreDevicesAndSensors: 'Restore devices and sensors',
  restoreDevicesAndSensorsDescription: 'This action will remove all added devices and sensors and restore the default configuration.',
  searchSystem: 'Search system',
  sensorRegistrationError: 'Error registering the sensor',
  sensors: 'Sensors',
  sensorSignDescription: 'With this option, you can change the sensor sign.',
  sensorSignTitle: 'Sensor sign (import/export)',
  setup: 'Settings',
  singlePhase: 'Single phase',
  systemName: 'System name',
  systemNamePlaceholder: 'E.g. Giovanni House',
  threePhase: 'Three phase',
  uniqueEmail: 'Email already inserted',
  uniqueSerial: 'The serial number must be unique',
  updateUsersAuthorizations: 'Update user authorization',
  upgradeFirmware: 'Upgrade Firmware',
  userManagement: 'User Management',
  userManagementDescription: 'Enter the emails of the users you want to add to your system',
  userManagementPlaceholder: 'E.g. user...@gmail.com',
  usersStepLabel: 'Users',

  cancel: "Cancel",
  connextOfflineToastContent: "The Connext is offline, please check the connection",
  connextOfflineToastTitle: "Connext offline",
  deletePlantContent: "Once you delete a plant, there is no going back. Please be certain",
  deletePlantDialogAction: "Got it, delete",
  UpdateUserPermissionAction: "Update",
  deletePlantDialogContentVirtual: "Are you sure you want to delete this system? This action cannot be undone.",
  deletePlantDialogContentWithConnext: "Are you sure you want to delete this system? As the owner of the Connext, all administrators will be removed, and the Connext will be reset. This action cannot be undone.",
  deletePlantDialogTitle: "Delete plant",
  deletePlantTitle: "Delete plant",
  deletePlantToastContent: "The system has been deleted",
  deletePlantToastTitle: "Delete plant",
  deletingPlant: "Deleting plant",

  installer: 'Installer',
  viewer: 'Viewer',

  verifiedPlant: 'Verified Plant',
  legacyPlant: 'Legacy Plant',
  legacyDescription: `
    <ul>
      <li><strong>Description:</strong> Create a photovoltaic system by entering the serial numbers of inverters and meters. This method does not include additional checks: you can use any serial number without restrictions.</li>
      <br>
      <li><strong>Functionality:</strong> Displays system telemetry without further verification.</li>
      <li><strong>Important:</strong> Legacy systems will soon no longer be available for creation.</li>
    </ul>`,
  verifyDescription: `
    <ul>
      <li><strong>Description:</strong> Create a photovoltaic system with advanced verification. This type of system offers greater guarantees and future features, such as advanced remote interactions.</li>
      <br>
      <li><strong>Features</strong></li>
      <ul>
        <li><strong>Serial Verification:</strong> An inverter can only be associated with one certified system, ensuring ownership uniqueness.</li>
        <li><strong>Claim Ownership:</strong> Associate the system with your account and add your installer to enable future remote interactions.</li>
      </ul>
    </ul>
    `,
    confirm: 'Confirm',

    userWarningTitle: "Attention",
    currentUserUpdatePermissionsWarning: "You are about to delete yourself from the system. This action cannot be undone.",
    removeUsersDialogTitle: "Remove users",
    removeUsersDialogContent: "{{emails}} will be removed and the current configuration will be saved. This action cannot be undone.",
    removeUsersDialogAction: "Remove",
    usersAddedToastTitle: "User added",
    usersAddedToastContent: "New user has been added successfully.",
    usersUpdatedToastTitle: "Authorizations updated",
    usersUpdatedToastContent: "User authorizations have been updated successfully.",
    usersRemovedToastTitle: "Users removed",
    usersRemovedToastContent: "Selected users have been removed from the system.",
    usersErrorToastTitle: "Error",
    usersErrorToastContent: "An error occurred while updating the user list. Please try again.",

    basicUserCanHaveOnly3Plant: "A basic user can have a maximum of 3 plants",
    ifYouHaveAnAzzurroHubLoggerYouNeedAnAdvancedPlant: "If you have an Azzurro Hub logger, you need to create an advanced plant.",
    thereAreUnsavedChanges: "There are unsaved changes",
    associatedAlarm: "Associated Alarm",
    noAlarmAssociated: "No Alarm Associated",

    notificationConfigurationTitle: "Notification configuration",
    notificationConfigurationSelected : "notification selected",
    notificationConfigurationAvailable: "notification available",
    notificationTableHeaderActions: "Actions",
    notificationTableHeaderCategories: "Categories",
    notificationTableHeaderDescription: "Description",
    notificationTableHeaderEventModelName: "Name",
    notificationTableNoResults: "No results found",
    notificationSearchPlaceholder: "Search",
    notificationCategoriesFilter: "categories filter",
    notificationActionSave: "Save",
    emailRecipients: "email recipients",
    emailRecipientsPlaceholder: "Select email recipients",
    weakBatteryName: "Weak battery",
    weakBatteryDescription: "The battery is weak",
    batteryLowName: "Battery low",
    batteryLowDescription: "The battery is low",
    gridOvervoltageName: "Grid Overvoltage",
    gridOvervoltageDescription: "The grid voltage (AC) is higher than the limits imposed by regulations.",
    gridUndervoltageName: "Grid Undervoltage",
    gridUndervoltageDescription: "The grid voltage (AC) is lower than the limits imposed by regulations.",
    gridOverfrequencyName: "Grid Overfrequency",
    gridOverfrequencyDescription: "The grid frequency (AC) is higher than the limits imposed by regulations.",
    gridUnderfrequencyName: "Grid Underfrequency",
    gridUnderfrequencyDescription: "The grid frequency (AC) is lower than the limits imposed by regulations.",

    leakageCurrentFaultName: "Leakage Current Fault",
    leakageCurrentFaultDescription: "Leakage current detected, indicating a potential fault.",
    islandingErrorName: "Islanding Error",
    islandingErrorDescription: "The inverter fails to detect that the photovoltaic system is isolated from the grid, posing a potential safety risk.",
    relayDetectionFailureName: "Relay Detection Failure",
    relayDetectionFailureDescription: "Malfunction in detecting the AC relay, which may prevent the circuit from opening or closing when needed.",
    lowInsulationResistanceName: "Low Insulation Resistance",
    lowInsulationResistanceDescription: "Low insulation resistance on the DC side.",
    ctErrorName: "CT Error",
    ctErrorDescription: "Error in the current transformer (CT), preventing accurate current measurement.",
    pvOvervoltageName: "PV Overvoltage",
    pvOvervoltageDescription: "An overvoltage has been detected in the photovoltaic panels, potentially causing damage to modules or the inverter.",
    meterErrorName: "Meter Error",
    meterErrorDescription: "Malfunction of the power meter, preventing accurate monitoring of exchanged energy.",
    batteryLowVoltageShutdownName: "Battery Low Voltage Shutdown",
    batteryLowVoltageShutdownDescription: "Battery is shutting down due to low voltage.",
    acHardwareOvercurrentFaultName: "Output Hardware Overcurrent Fault",
    acHardwareOvercurrentFaultDescription: "Permanent fault due to an overcurrent in the system’s hardware output.",
    busOvervoltageFaultName: "Bus Overvoltage Fault",
    busOvervoltageFaultDescription: "Permanent overvoltage in the system bus, potentially damaging internal components.",
    busHardwareOvervoltageFaultName: "Bus Hardware Overvoltage Fault",
    busHardwareOvervoltageFaultDescription: "Permanent hardware fault caused by an overvoltage in the bus.",
    pvUnevenCurrentFaultName: "PV Uneven Current Fault",
    pvUnevenCurrentFaultDescription: "Uneven current flow detected from the photovoltaic panels, indicating a possible fault.",
    epsBatteryOvercurrentFaultName: "Battery Overcurrent in EPS Mode",
    epsBatteryOvercurrentFaultDescription: "Permanent battery overcurrent while the system is in EPS (Emergency Power Supply) mode.",
    outputInstantaneousOvercurrentFaultName: "Output Instantaneous Overcurrent Fault",
    outputInstantaneousOvercurrentFaultDescription: "A transient overcurrent persists at the output, potentially damaging the inverter.",
    acCurrentUnbalanceFaultName: "Output Current Unbalance Fault",
    acCurrentUnbalanceFaultDescription: "Permanent unbalance in the output current, which could damage the system.",
    inverterSoftStartFailureName: "Inverter Soft Start Failure",
    inverterSoftStartFailureDescription: "Fault in the inverter’s soft start process, which may lead to malfunctions.",
    inputModeSettingFailureName: "Input Mode Setting Failure",
    inputModeSettingFailureDescription: "Permanent error in the input mode setting configuration.",
    inputOvercurrentFaultName: "Input Overcurrent Fault",
    inputOvercurrentFaultDescription: "Permanent fault caused by an overcurrent at the system input.",
    inputHardwareOvercurrentFaultName: "Input Hardware Overcurrent Fault",
    inputHardwareOvercurrentFaultDescription: "Permanent hardware overcurrent at the system input.",
    relayUnbalancedPermanentFailureName: "Relay Permanent Fault",
    relayUnbalancedPermanentFailureDescription: "Permanent fault in the relay, potentially preventing proper system operation.",
    busUnbalanceFaultName: "Bus Unbalance Fault",
    busUnbalanceFaultDescription: "Permanent fault caused by an imbalance in the system bus.",
    spiCommError_DCName: "SPI Communication Error (DC Side)",
    spiCommError_DCDescription: "Problem in the SPI communication inside the inverter.",
    spiCommError_ACName: "SPI Communication Error (AC Side)",
    spiCommError_ACDescription: "Problem in the SPI communication inside the inverter.",
    safetyVerFaultName: "Safety Regulation Version Error",
    safetyVerFaultDescription: "Error in the version of the safety regulation file.",
    sciError_DCName: "SCI Communication Error (DC Side)",
    sciError_DCDescription: "SCI communication issue on the DC side.",
    sciError_ACName: "SCI Communication Error (AC Side)",
    sciError_ACDescription: "SCI communication error on the AC side.",
    sciError_FuseName: "Convergence Board Communication Error",
    sciError_FuseDescription: "Detection of a communication error with the convergence board.",
    inconsistentSoftwareVersionName: "Inconsistent Software Version",
    inconsistentSoftwareVersionDescription: "An inconsistency has been detected between software versions.",
    bms1CommunicatonFaultName: "Battery 1 Communication Error",
    bms1CommunicatonFaultDescription: "Malfunction in communication with battery 1.",
    bms2CommunicatonFaultName: "Battery 2 Communication Error",
    bms2CommunicatonFaultDescription: "Communication error with battery 2.",
    fan1FailureName: "Fan 1 Failure",
    fan1FailureDescription: "Failure of fan 1.",
    fan2FailureName: "Fan 2 Failure",
    fan2FailureDescription: "Failure of fan 2.",
    fan3FailureName: "Fan 3 Failure",
    fan3FailureDescription: "Failure of fan 3.",
    fan4FailureName: "Fan 4 Failure",
    fan4FailureDescription: "Failure of fan 4.",
    fan5FailureName: "Fan 5 Failure",
    fan5FailureDescription: "Failure of fan 5.",
    fan6FailureName: "Fan 6 Failure",
    fan6FailureDescription: "Failure of fan 6.",
    fan7FailureName: "Fan 7 Failure",
    fan7FailureDescription: "Failure of fan 7.",
    bmsOvervoltageProtectionName: "BMS Overvoltage Alarm",
    bmsOvervoltageProtectionDescription: "Overvoltage alarm in the Battery Management System (BMS).",
    bmsUndervoltageProtectionName: "BMS Undervoltage Alarm",
    bmsUndervoltageProtectionDescription: "Undervoltage alarm in the BMS, indicating a critically low battery charge.",
    bmsVerFaultName: "BMS Version Inconsistency",
    bmsVerFaultDescription: "Firmware version discrepancy in the BMS.",
    ZBTS5kSleepModeName: "ZBTS5k Sleep Mode",
    ZBTS5kSleepModeDescription: "The ZBTS5k inverter is in sleep mode.",
    gpmErrorName: "Power Magic Error",
    gpmErrorDescription: "Generic Power Magic event with severity: error.",
    gpmNoticeName: "Power Magic Notice",
    gpmNoticeDescription: "Generic Power Magic event with severity: notice.",
    gpmWarningName: "Power Magic Warning",
    gpmWarningDescription: "Generic Power Magic event with severity: warning.",
    remove: "Remove",

    // Azzurro Hub Device Detection labels
    addDevice: 'Add Device',
    detectedDevices: 'Devices Detected by Hub',
    detectedDevicesDescription: 'These devices were automatically detected by your Azzurro Hub. Click to add them to your plant.',
    manualDeviceList: 'Manual Device Entry',
    manualDeviceListDescription: 'Manually enter device serial numbers. You take responsibility for the accuracy of the serials entered.',
    manualDeviceListPlaceholder: 'E.g. ZM24D12345678',
    noDetectedDevices: 'No devices detected',
    noAddedDevices: 'No devices added',
    noAddedDevicesDescription: 'No devices have been added to this plant yet. Only inverters, meters, and Power Magic devices appear in this list. EMS devices are not shown here.',
    advanced: 'Advanced',
    advancedDescription: 'Manual device entry and advanced options',
    azzurroHubOffline: 'Azzurro Hub offline',
    devicesAddedToAdvancedPlant: 'Devices Added to Advanced Plant',
    clickToAddToYourPlant: 'Click to add them to your plant',
    scanning: 'Scanning...',
    listFoundDevices: 'List Found Devices',
    refreshDevices: 'Refresh',
    startRescan: 'Start Re-scan',

    unauthorized: 'Unauthorized',
    deviceDisconnected: 'Device disconnected',
    unknown: 'Unknown',
    timeout: 'Timeout exceeded',

    activeTimeMinutes: 'Active time',
    recurringEmailIntervalMinutes: 'Recurring email interval',
    snoozeDurationMinutes: 'Snooze duration',
    voltageThreshold: 'Voltage threshold',
    socThreshold: 'SoC threshold',
    sleepModeDurationMinutes: 'Sleep mode duration',
    minVoltageThreshold: 'Min voltage threshold',
    maxVoltageThreshold: 'Max voltage threshold',
    timeUnitMinutes: 'minutes',
    timeUnitHours: 'hours',
    timeUnitDays: 'days',
    timeUnitMinutesShort: 'm',
    timeUnitHoursShort: 'h',
    timeUnitDaysShort: 'd',
    notificationValueBetweenMinutes: 'Value must be between {{ min }} and {{ max }} minutes',
    activeTimeMinutesTooltip: 'Time the event must stay active before notifications are sent.',
    recurringEmailIntervalMinutesTooltip: 'How often to resend the notification while the event remains active.',
    snoozeDurationMinutesTooltip: 'Temporary pause after a notification before sending the next one.',
    voltageThresholdTooltip: 'Voltage limit that triggers the event when crossed.',
    socThresholdTooltip: 'State of Charge limit that triggers the event when crossed.',
    sleepModeDurationMinutesTooltip: 'How long the device stays in sleep mode before resuming checks.',
    minVoltageThresholdTooltip: 'Lower voltage limit used to trigger the event.',
    maxVoltageThresholdTooltip: 'Upper voltage limit used to trigger the event.',
    change: 'Change',
});

export const labels = getLabels();
export type CreateLabels = typeof labels;
